import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentModule} from 'app/component/component.module';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {HteComponent} from './hte.component';

@NgModule({
    imports: [ComponentModule, CommonModule],
    declarations: [HteComponent],
    entryComponents: [HteComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(HteComponent),
            multi: true,
        },
    ],
})
export class HteModule {}
